import {BaseService} from './Core/BaseService';
import {BaseSearchableService} from "./Core/BaseSearchableService";

class ProjectService extends BaseSearchableService {
    get Url() { return super.Url + "/projects"; }
    get ModelName() { return "Projects"; }
    get PrimaryKeyProperty() { return "projectId"; }

    GetProjects() {
        return this.SendRequest(BaseService.GET);
    }

    Search(name, additionalParameters = null) {
        let request = {
            name: name,
            search: true,
            ...additionalParameters
        };

        return this.SendRequest(BaseService.GET, request);
    }

    GetChildrenProjects(parentId) {
        let request = {parentId: parentId};
        return this.SendRequest(BaseService.GET, request);
    }

    GetProject(projectId) {
        return this.SendRequest(BaseService.GET, projectId);
    }

    UpdateProject(project) {
        return this.SendRequest(BaseService.PUT, project);
    }

    CreateProject(project) {
        return this.SendRequest(BaseService.POST, project);
    }

    DeleteProject(projectId) {
        return this.SendRequest(BaseService.DELETE, projectId);
    }
    
    ProjectReportURL(project) {
        return "/reportBuilder?" + (new URLSearchParams({
            projectId: project?.projectId,
            reportTypeId: 3,
        }).toString());
    }
}

export const service = new ProjectService();

